<template>
	<div>
		<v-container v-if="pedido">
			<v-breadcrumbs
				:items="[
					{ text: `${$options.filters.trans('store')}`, to: '/' },
					{ text: `${$options.filters.trans('orders')}`, to: '/profile' },
					{ text: `${$options.filters.trans('order')} #${pedido.numero_pedido}`, disabled: true },
				]"
			></v-breadcrumbs>
			<v-layout row class="pa-3">
				<v-flex xs9>
					<h2>{{ "order" | trans }} #{{ pedido.numero_pedido }}</h2>
					<h3>{{ "client" | trans }}: {{ pedido.cliente.full_name }}</h3>
				</v-flex>
				<v-flex xs3 class="text-right">
					<v-chip
						class="mr-5"
						:color="
							`${pedido.estado}`.toLocaleLowerCase().includes('error')
								? 'red'
								: pedido.estado == 'pagado'
								? 'primary'
								: 'orange'
						"
						dark
						label
					>
						{{ pedido.estado }}
					</v-chip>
				</v-flex>
			</v-layout>
			<v-card>
				<v-card-text>
					<v-layout row wrap class="pa-3">
						<v-flex xs8>
							<h3 class="body-1 primary--text">
								<b>{{ "total" | trans }}:</b>
								{{ pedido.total | currency("$", 0) }}
							</h3>
							<h3 v-if="pedido.items.length > 0">{{ pedido.items.length }} items</h3>
						</v-flex>
						<v-flex xs4 class="text-right">
							<p class="body-1">{{ pedido.created_at | moment("calendar") }}</p>
						</v-flex>
						<v-flex xs12 v-if="pedido.items">
							<v-divider></v-divider>
							<v-list dense>
								<template v-for="prod in pedido.items">
									<v-list-item :key="prod.id">
										<v-list-item-content>
											<v-list-item-title>{{ prod.name }}</v-list-item-title>
											<v-list-item-title>{{ prod.cantidad_pedidos }}</v-list-item-title>
											<v-list-item-subtitle>{{ prod.precio | currency("$", 0) }}</v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>{{
											(prod.cantidad_pedidos * prod.precio) | currency("$", 0)
										}}</v-list-item-action>
									</v-list-item>
									<v-divider :key="'div-' + prod.id"></v-divider>
								</template>
							</v-list>
						</v-flex>
						<v-flex xs4 class="text-right">
							<v-btn
								dark
								color="green darken-2"
								@click="payment(pedido.id, 'payu')"
								v-if="
									api.user.can_pay_with_payu &&
									(pedido.estado == 'Pendiente de Pago' ||
										pedido.estado == 'no pagado' ||
										pedido.estado == 'Error en el Pago')
								"
							>
								<div>Pago En Linea con</div>
								<v-img
									contain
									height="20px"
									src="https://colombia.payu.com/wp-content/themes/global-website/assets/src/images/payu-logo.svg"
								></v-img>
							</v-btn>
							<v-btn
								dark
								color="grey darken-2"
								@click="payment(pedido.id, 'PLACE_TO_PAY')"
								height="150px"
								block
								contain
								v-if="
									api.user.can_pay_with_place_to_pay &&
									(pedido.estado == 'Pendiente de Pago' ||
										pedido.estado == 'no pagado' ||
										pedido.estado == 'Error en el Pago')
								"
							>
								<div class="layout column">
									<div>Pago En Linea con</div>
									<img
										class="mt-3 mx-auto"
										style="height: 50px"
										src="https://static.placetopay.com/placetopay-logo.svg"
									/>
								</div>
							</v-btn>
							<p class="body-1">{{ pedido.created_at | moment("calendar") }}</p>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-container>
		<v-container v-else class="text-center">
			<v-progress-circular indeterminate color="primary"></v-progress-circular>
			<v-skeleton-loader type="list-item-three-line" class="mb-3" />
			<v-skeleton-loader type="list-item-three-line" class="mb-3" />
			<v-skeleton-loader type="list-item-three-line" class="mb-3" />
			<v-skeleton-loader type="list-item-three-line" class="mb-3" />
			<v-skeleton-loader type="list-item-three-line" class="mb-3" />
		</v-container>
	</div>
</template>

<script>
export default {
	name: "Order",
	mounted() {
		this.getData();
	},
	methods: {
		async getData() {
			const orderId = this.orderId;
			const pedido = (await this.api.get(`pedidos/${orderId}?include=cliente,items`)).data;
			this.pedido = pedido;
		},
		payment(pedId, method = "payu") {
			this.api.payment(pedId, method);
		},
	},
	data() {
		return {
			pedido: null,
		};
	},
	props: {
		orderId: {
			type: [Number, String],
			required: true,
		},
	},
};
</script>
